<div
  appGlossScroll
  appModalOverlay
  [appModalOverlayLabel]="'more' | i18n"
  (modalOverlayDismiss)="closed.emit()"
  class="tw-fixed tw-inset-0 tw-z-[100] tw-flex tw-flex-col tw-overflow-y-auto tw-bg-dt-surface-page tw-px-7 tw-pb-8 tw-pt-[calc(1.5rem+var(--safe-area-top,0px))]"
>
  <!-- Decorative ambient glow behind the glass panels (matches Figma background ellipses) -->
  <div
    class="tw-pointer-events-none tw-fixed tw-inset-0 tw-overflow-hidden dark:tw-opacity-50"
    aria-hidden="true"
  >
    <div
      class="tw-absolute tw-left-[-20%] tw-top-[60%] tw-h-[300px] tw-w-[300px] tw-rounded-full tw-bg-teal-300/30 tw-blur-[80px]"
    ></div>
    <div
      class="tw-absolute tw-left-[60%] tw-top-[75%] tw-h-[280px] tw-w-[280px] tw-rounded-full tw-bg-dt-indigo-7/30 tw-blur-[80px]"
    ></div>
    <div
      class="tw-absolute tw-left-[15%] tw-top-[85%] tw-h-[240px] tw-w-[240px] tw-rounded-full tw-bg-dt-slate-7/30 tw-blur-[80px]"
    ></div>
  </div>

  <div class="tw-relative tw-mb-[18px] tw-flex tw-h-7 tw-items-center tw-justify-center">
    <p class="tw-font-montserrat tw-text-[22px] tw-font-bold tw-text-dt-text-headings">
      {{ "more" | i18n }}
    </p>
    <close-button
      class="tw-absolute tw-right-0 tw-top-1/2 -tw-translate-y-1/2"
      type="plain"
      [isMatDialog]="false"
      (closeClickedEvent)="closed.emit()"
    ></close-button>
  </div>

  <div class="tw-relative tw-flex tw-flex-col tw-gap-5">
    @if (tools.length) {
      <div class="tw-flex tw-flex-col tw-gap-2">
        <p
          class="tw-font-montserrat tw-text-[12px] tw-font-semibold tw-uppercase tw-leading-5 tw-tracking-[0.7px] tw-text-dt-text-tertiary"
        >
          {{ "yourTools" | i18n }}
        </p>
        <div class="tw-grid tw-grid-cols-4 tw-items-start tw-gap-3">
          @for (tool of tools; track tool.key) {
            <button
              type="button"
              class="tw-flex tw-min-w-0 tw-flex-col tw-items-center tw-gap-[7px] tw-rounded-2xl tw-border-none tw-bg-transparent tw-p-0 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-color-action-primary"
              (click)="toolSelected.emit(tool)"
            >
              <span
                class="tw-flex tw-h-[52px] tw-w-[52px] tw-items-center tw-justify-center tw-rounded-2xl tw-bg-color-surface-elevated tw-shadow-elevation-control"
              >
                <svg class="tw-h-[22px] tw-w-[22px] tw-text-dt-text-action">
                  <use [attr.xlink:href]="'images/sprite.svg#' + tool.icon" />
                </svg>
              </span>
              <span
                class="tw-line-clamp-2 tw-w-full tw-text-center tw-font-montserrat tw-text-[12px] tw-font-medium tw-leading-4 tw-text-dt-text-headings"
                [title]="tool.label | i18n"
                >{{ tool.label | i18n }}</span
              >
            </button>
          }
        </div>
      </div>
    }

    <div class="tw-flex tw-flex-col tw-gap-2">
      <p
        class="tw-font-montserrat tw-text-[12px] tw-font-semibold tw-uppercase tw-leading-5 tw-tracking-[0.7px] tw-text-dt-text-tertiary"
      >
        {{ "primaryNavigation" | i18n }}
      </p>
      <div
        class="tw-flex tw-h-[58px] tw-items-center tw-justify-between tw-rounded-full tw-border tw-border-l tw-border-t tw-border-white/70 tw-p-1 dark:tw-border-white/[0.18] tw-backdrop-blur-[3px] tw-bg-white/40 dark:tw-bg-white/[0.06] tw-shadow-elevation-glass-panel"
      >
        @for (item of pinnedItems; track item.key) {
          <button
            type="button"
            class="tw-flex tw-h-full tw-min-w-0 tw-flex-1 tw-flex-col tw-items-center tw-justify-center tw-gap-0 tw-rounded-full tw-border-none tw-bg-transparent tw-px-1 tw-pb-1 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-color-action-primary"
            (click)="itemSelected.emit(item)"
          >
            <svg class="tw-h-6 tw-w-6 tw-shrink-0 tw-text-dt-text-headings">
              <use [attr.xlink:href]="'images/sprite.svg#' + item.icon" />
            </svg>
            <span
              class="tw-max-w-full tw-truncate tw-font-montserrat tw-text-[11px] tw-font-medium tw-leading-[1.25] tw-text-teal-900 dark:tw-text-dt-text-secondary"
              [title]="item.label | i18n"
              >{{ item.label | i18n }}</span
            >
          </button>
        }
      </div>
    </div>

    <div class="tw-flex tw-flex-col tw-gap-2">
      <p
        class="tw-font-montserrat tw-text-[12px] tw-font-semibold tw-uppercase tw-leading-5 tw-tracking-[0.7px] tw-text-dt-text-tertiary"
      >
        {{ "otherFeatures" | i18n }}
      </p>
      <div class="tw-grid tw-grid-cols-3 tw-gap-2">
        <!-- Settings is pinned to the tab bar, so there's no "before Settings" slot in this grid. -->
        @if (!hasSettingsInOtherItems()) {
          <ng-container *ngTemplateOutlet="monthlySummaryAction"></ng-container>
        }
        @for (item of gridItems(); track item.key) {
          @if (item.key === GlossRoutes.Settings) {
            <ng-container *ngTemplateOutlet="monthlySummaryAction"></ng-container>
          }
          <button
            type="button"
            class="tw-flex tw-h-16 tw-min-w-0 tw-flex-col tw-items-center tw-justify-center tw-gap-1 tw-rounded-2xl tw-border tw-border-l tw-border-t tw-border-white/60 tw-px-1 dark:tw-border-white/[0.18] tw-backdrop-blur-[3px] tw-bg-white/40 dark:tw-bg-white/[0.06] tw-shadow-elevation-glass-panel focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-color-action-primary"
            (click)="itemSelected.emit(item)"
          >
            <svg class="tw-h-5 tw-w-5 tw-shrink-0 tw-text-dt-text-headings">
              <use [attr.xlink:href]="'images/sprite.svg#' + item.icon" />
            </svg>
            <span
              class="tw-max-w-full tw-truncate tw-font-montserrat tw-text-[12px] tw-font-medium tw-leading-4 tw-text-dt-text-headings"
              [title]="item.label | i18n"
              >{{ item.label | i18n }}</span
            >
          </button>
        }
      </div>
    </div>

    <button
      type="button"
      class="tw-mt-1 tw-flex tw-h-12 tw-w-full tw-items-center tw-justify-center tw-rounded-2xl tw-border-none tw-bg-color-surface-card tw-font-montserrat tw-text-[16px] tw-font-semibold tw-text-dt-text-action tw-shadow-elevation-card"
      (click)="editNavigation.emit()"
    >
      {{ "editNavigation" | i18n }}
    </button>
  </div>
</div>

<!-- Fixed action, not part of the pinnable/reorderable nav item list — always sits directly
     before Settings regardless of which section the user has it in. -->
<ng-template #monthlySummaryAction>
  @if (monthlySummaryEnabled()) {
    <button
      type="button"
      class="tw-flex tw-h-16 tw-min-w-0 tw-flex-col tw-items-center tw-justify-center tw-gap-1 tw-rounded-2xl tw-border tw-border-l tw-border-t tw-border-white/60 tw-px-1 dark:tw-border-white/[0.18] tw-backdrop-blur-[3px] tw-bg-white/40 dark:tw-bg-white/[0.06] tw-shadow-elevation-glass-panel focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-color-action-primary"
      (click)="monthlySummarySelected.emit()"
    >
      <svg class="tw-h-5 tw-w-5 tw-shrink-0 tw-text-dt-text-headings">
        <use xlink:href="images/sprite.svg#bar-chart-line" />
      </svg>
      <span
        class="tw-max-w-full tw-truncate tw-font-montserrat tw-text-[12px] tw-font-medium tw-leading-4 tw-text-dt-text-headings"
        [title]="'monthlySummary' | i18n"
        >{{ "monthlySummary" | i18n }}</span
      >
    </button>
  }
</ng-template>
